import React, { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import FormLabel from "react-bootstrap/FormLabel";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { Formik } from "formik";
import Select from "../../ui/select";
import {configuracionFormAction, obtenerInstanciasEventoAction, obtenerEventosBitacoraAction} from "../../store/actions/bitacora-action";
import { LoadingComponent } from "recupero-comunes";
import "recupero-comunes/dist/index.css";

const BandejaEventos = ({rutcia, idCaso}) => {
  const intanciasRef = useRef(null);

  const [loading, setLoading] = useState(false);
  const [instanciasFiltradas, setInstanciasFiltradas] = useState([]);

  const data_bitacora = useSelector((state) => state.bitacora);
  const { cfg_form, bitacora, instancias } = data_bitacora;

  const dispatch = useDispatch();

  useEffect(() => {
    // @TODO: reemplazar valor estáticos.
    let query = Buffer.from(
      JSON.stringify({ idform: 2, rutcia: rutcia })
    ).toString("base64");
    dispatch(configuracionFormAction(query));
  }, [dispatch]);

  useEffect(() => {
    // @TODO: reemplazar valor estáticos.
    let query = Buffer.from(
      JSON.stringify({ rutcia: rutcia, concepto: 221 })
    ).toString("base64");
    dispatch(obtenerInstanciasEventoAction(query));
  }, [dispatch]);

  useEffect(() => {
    if (instancias) {
      let instanciasFiltradas = [];
      /*instancias.forEach(instancia => {
                if (instancia.id == 221003 || instancia.id == 221011) {
                    instanciasFiltradas.push(instancia);
                }
            });*/
      instanciasFiltradas = instancias;
      setInstanciasFiltradas(instanciasFiltradas);
    }
  }, [instancias]);

  /*useEffect(() => {

        setLoading(true);
        let query = Buffer.from(JSON.stringify({ "idCaso": 5})).toString('base64');
        dispatch(obtenerEventosBitacoraAction(query)).then(() => {
            setLoading(false);
        });

    }, [dispatch]);*/

  const handleReload = () => {
    if (bitacora && bitacora.query) {
      setLoading(true);

      // Obtener última query enviada
      let query = bitacora.query;
      // Ejecutar acción para obtener casos.
      dispatch(obtenerEventosBitacoraAction(query)).then(() => {
        setLoading(false);
      });
    }
  };
  const onSubmit = (values) => {
    setLoading(true);

    let query = { idCaso: idCaso };
    /*for (let key in values) {
            if (values[key] && values[key] !== null && values[key] !== "") {
                query[key] = values[key];
            }
        }*/
    query = Buffer.from(JSON.stringify(query)).toString("base64");

    dispatch(obtenerEventosBitacoraAction(query)).then(() => {
      setLoading(false);
    });
  };
  const obtenerEventosByInstancia = (e) => {
    let id = e[0].id;

    let query = { idCaso: idCaso, instanciaEvento: id };
    query = Buffer.from(JSON.stringify(query)).toString("base64");
    setLoading(true);

    dispatch(obtenerEventosBitacoraAction(query)).then(() => {
      setLoading(false);
    });
  };
  const obtenerColumnas = () => {
    return [
      {
        dataField: "instaEvento",
        text: cfg_form["bitacora-grilla-instancia"],
        sort: true,
        headerAlign: "center",
        align: "center",
        headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
          <div>
            {column.text}
            <br />
            {sortElement}
          </div>
        ),
      },
      {
        dataField: "tipoEvento",
        text: cfg_form["bitacora-grilla-tipoevento"],
        sort: true,
        headerAlign: "center",
        align: "center",
        headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
          <div>
            {column.text}
            <br />
            {sortElement}
          </div>
        ),
      },
      {
        dataField: "fechaOcurrenciaFormato",
        text: cfg_form["bitacora-grilla-fechaocu"],
        sort: true,
        headerAlign: "center",
        align: "center",
        headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
          <div>
            {column.text}
            <br />
            {sortElement}
          </div>
        ),
      },
      {
        dataField: "fechaIngresoFormato",
        text: cfg_form["bitacora-grilla-fechareg"],
        sort: true,
        headerAlign: "center",
        align: "center",
        headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
          <div>
            {column.text}
            <br />
            {sortElement}
          </div>
        ),
      },
      {
        dataField: "responsable",
        text: cfg_form["bitacora-grilla-usuario"],
        sort: true,
        headerAlign: "center",
        align: "center",
        headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
          <div>
            {column.text}
            <br />
            {sortElement}
          </div>
        ),
      },
      {
        dataField: "minuta",
        text: cfg_form["bitacora-grilla-obs"],
        sort: false,
        headerAlign: "center",
        align: "center",
        headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
          <div>
            {column.text}
            <br />
            {sortElement}
          </div>
        ),
      },
    ];
  };

  return (
    <div>
      <LoadingComponent show={loading} />
      {cfg_form ? (
        <div>
          <Formik
            initialValues={{
              instanciaEvento: "",
            }}
            validationSchema={null}
            initialTouched={{}}
            validateOnChange={false}
            validateOnBlur={false}
            onSubmit={() => {
              onSubmit;
            }}
          >
            {({ values, handleSubmit, setFieldValue, resetForm }) => (
              <Form noValidate onSubmit={handleSubmit}>
                <Row className="mt-4">
                  <Col md="3">
                    <Select
                      ref={intanciasRef}
                      name="instanciaEvento"
                      label={cfg_form["bitacora-cmb-instancias"]}
                      labelKey="nombre"
                      options={instanciasFiltradas ? instanciasFiltradas : []}
                      onChange={obtenerEventosByInstancia}
                    />
                  </Col>
                  <Col></Col>
                  <Col md="8">
                    <FormLabel>
                      <br></br>
                      <br></br>
                    </FormLabel>
                    <Button
                      className="btn btn-secondary"
                      onClick={() => {
                        onSubmit(values);
                      }}
                    >
                      {cfg_form["bitacora-boton-vertodos"]}
                    </Button>
                  </Col>
                </Row>
              </Form>
            )}
          </Formik>
          <ToolkitProvider
            search
            bootstrap4
            keyField="IdCaso"
            data={bitacora ? bitacora.eventos : []}
            columns={obtenerColumnas()}
            defaultSorted={[{ dataField: "id", order: "asc" }]}
          >
            {(props) => (
              <div>
                <Row>
                  <Col
                    md={12}
                    className="d-grid gap-2 d-md-flex justify-content-md-end mt-2 mb-2"
                  >
                    <Form.Control
                      placeholder="Buscar en la grilla"
                      className="w-25"
                      onChange={(e) => {
                        props.searchProps.onSearch(e.target.value);
                      }}
                    />
                    <Button
                      type="button"
                      variant="outline-secondary"
                      size="sm"
                      onClick={() => {
                        handleReload();
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-arrow-clockwise"
                        viewBox="0 0 16 16"
                      >
                        <path
                          fillRule="evenodd"
                          d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z"
                        />
                        <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z" />
                      </svg>
                    </Button>
                  </Col>
                </Row>
                <BootstrapTable
                  {...props.baseProps}
                  headerWrapperClasses="table-secondary"
                  pagination={paginationFactory()}
                  noDataIndication={
                    <div className="text-center">
                      No hay registros encontrados
                    </div>
                  }
                />
              </div>
            )}
          </ToolkitProvider>
        </div>
      ) : null}
    </div>
  );
};

export default BandejaEventos;
